import { messages } from '@atlassian/notification-common';
import { RequestCategory } from '@atlassian/notification-common/types';
export var notificationListCategoryFilters = [{
  key: RequestCategory.DIRECT,
  icon: '',
  label: messages.direct
}, {
  key: RequestCategory.NONE,
  icon: '',
  label: messages.watching
}];
export var notificationListProductFilters = [];